import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Accordion as BaseAccordion } from '@base-ui-components/react';
import { forwardRef } from 'react';
/**
 * A component that lets users show and hide sections of related content on a page.
 */
export const Accordion = forwardRef(({ hiddenUntilFound = true, ...props }, ref) => (_jsx(BaseAccordion.Root, { hiddenUntilFound: hiddenUntilFound, ref: ref, ...props })));
